import React from 'react';
import { Typography, Button } from 'antd';
// Hooks
import { PpvTier } from 'hooks/useGetPpvTiers';
// Components
import ChipSelect from 'components/common/ChipSelect/ChipSelect';
// Styles
import styles from './PriceTierSelector.module.scss';

const { Text } = Typography;

type Props = {
  tiers: PpvTier[];
  loading?: boolean;
  error?: boolean;
  onRetry?: () => void;
  disabled?: boolean;
  // Supplied by antd Form.Item, so callers react to a pick via onSelect.
  value?: number | null;
  onChange?: (value: number) => void;
  onSelect?: (value: number) => void;
};

const PriceTierSelector: React.FC<Props> = ({
  tiers,
  loading = false,
  error = false,
  onRetry,
  disabled = false,
  value,
  onChange,
  onSelect,
}) => {
  if (loading && tiers.length === 0) {
    return (
      <div className={styles.state}>
        <Text type="secondary">Loading price options…</Text>
      </div>
    );
  }

  if (!disabled && (error || tiers.length === 0)) {
    return (
      <div className={styles.state}>
        <Text type="danger">Couldn&apos;t load price options</Text>
        {onRetry && (
          <Button type="link" size="small" onClick={onRetry}>
            Retry
          </Button>
        )}
      </div>
    );
  }

  return (
    <ChipSelect
      options={tiers.map((tier) => ({
        value: tier.price,
        label: `$${tier.price}`,
      }))}
      value={value}
      disabled={disabled}
      onChange={(price) => {
        onChange?.(price);
        onSelect?.(price);
      }}
    />
  );
};

export default PriceTierSelector;
